<template>
  <div class="introduce-content ">
    <p>introduce</p>
  </div>
</template>
<script>

export default {
  components:{
    
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scope>
.introduce-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}
</style>